<template>
  <el-dialog
    :visible.sync="centerDialogVisible"
    width="200px"
    center
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    modal-append-to-body
    destroy-on-close
    :lock-scroll="true"
  >
    <div class="loadingDialog">
      <lottie-layout :width="138" :height="138" :options="{
      loop: true,
      autoplay:true,
      animationData: 'https://tourimage.huayitraveltd.com/appResource/lottie/blue-loading.json'
    }" :title="title" />
    </div>
  </el-dialog>
</template>

<script>
import LottieLayout from './lottieLayout'
export default {
  name: 'loadingDialog',
  components: {LottieLayout},
  props: {
    centerDialogVisible: false,
    title: {
      type: String | Number,
      default: '加載中'
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-dialog__header{
  display: none;
}
/deep/ .el-dialog--center{
  border-radius: 15px;
}
.loadingDialog{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/global/lottie/loadingDialog.vue